import {Injectable} from '@angular/core';
import {RouterPaths} from "../config/router-paths.model";
import {Router} from "@angular/router";

@Injectable({
    providedIn: 'root'
})
export class NavigationService {

    constructor(private router: Router) {
    }

    goToHomePage() {
        this.changePageSavingQueryParams(RouterPaths.home);
        //this.mainTabsService.resetActiveTab();
    }

    goToSettingsPage() {
        this.changePageSavingQueryParams(RouterPaths.settings);
    }

    goToTermsPage() {
        this.changePageSavingQueryParams(RouterPaths.termsAndConditions);
    }

    goToSupport() {
        this.changePageSavingQueryParams(RouterPaths.support);
    }

    changePageSavingQueryParams(url) {
        this.router.navigate([url], { queryParamsHandling: "merge" });
    }
}
